import React, { type ComponentProps } from 'react'
import { SwipeableGrid, useContainerWidth } from '@fs/zion-ui'

type CardCarouselProps = {
  children: ComponentProps<typeof SwipeableGrid>['children']
  columnCount?: ComponentProps<typeof SwipeableGrid>['columnCount']
  'aria-label'?: string
}

export default function CardCarousel({
  children,
  columnCount,
  'aria-label': ariaLabel,
}: CardCarouselProps): JSX.Element {
  const atWidth = useContainerWidth()
  return (
    <SwipeableGrid
      gutters="xs"
      columnCount={columnCount || atWidth({ default: 1, sm: 2, md: 3, xl: 4, xxl: 5 })}
      aria-label={ariaLabel}
    >
      {children}
    </SwipeableGrid>
  )
}
